import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map",
  "use": "icon-map-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-map\"><path d=\"M15.333 1.333l-.86.362-4.048 1.644-4.66-1.662-.229-.073-.229.09L1.03 3.43l-.362.145v11.093l.859-.361 4.049-1.645 4.66 1.663.229.072.229-.09 4.277-1.735.363-.144V1.334zM6.167 3.05l3.666 1.3v8.6l-3.666-1.3v-8.6zm-1.223.036v8.582L1.89 12.914V4.333l3.055-1.247zm9.167 0v8.582l-3.056 1.246V4.333l3.056-1.247z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol